/**
 * Custom window events dispatched across the app.
 * Import from here instead of repeating `tcgeasy:…` string literals.
 */

export const windowEvents = {
  inventoryUpdated: 'tcgeasy:inventory-updated',
  rateLimit: 'tcgeasy:rate-limit',
} as const
